import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SocketService {
    private socket!: Socket;
    private readonly url = environment.socketUrl;

    constructor() {
        this.initializeSocket();
    }
    private initializeSocket(): void {
        this.socket = io(this.url, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            rejectUnauthorized: false, // Only for testing SSL issues
            secure: true,
            upgrade: true // Allow fallback to polling if needed
        });
        this.socket.on('connect', () => {
        
        });
    }
  joinRoom(userId: string): void {
    this.socket.emit('joinRoom', { userId });
  }

  // Listen for notification count
  getNotificationCount(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on('notificationCount', (data) => {
        subscriber.next(data);
      });

      // Cleanup on unsubscribe
      return () => {
        this.socket.off('notificationCount');
      };
    });
  }

    // Check if socket is connected
  isConnected(): boolean {
    return this.socket && this.socket.connected;
  }

  // Disconnect
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

}